var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGround(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_",
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legend-Expanded",
    transform: "translate(-799.000000, -768.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(586.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schematic-View",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-_x2B_-Component-Copy-2",
    transform: "translate(148.000000, 593.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(4.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-4",
    fill: "#FFFFFF",
    d: "M29.5,36c1.518,0,2.5,0.982,2.5,2.5S31.018,41,29.5,41h-7 c-1.517,0-2.5-0.982-2.5-2.5s0.983-2.5,2.5-2.5H29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-4_1_",
    fill: "#FFFFFF",
    d: "M49.5,4C51.018,4,52,4.983,52,6.5S51.018,9,49.5,9h-47C0.983,9,0,8.017,0,6.5 S0.983,4,2.5,4H49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    fill: "#FEFEFE",
    d: "M19.541,6.479c0,3.566,2.891,6.449,6.458,6.449c3.563,0,6.46-2.883,6.46-6.449 c0-3.567-2.896-6.454-6.46-6.454C22.432,0.024,19.541,2.911,19.541,6.479z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12_1_",
    fill: "#FEFEFE",
    d: "M32.459,6.479c0-3.567-2.896-6.454-6.46-6.454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-4_2_",
    fill: "#FFFFFF",
    d: "M42.484,15.063c1.517,0,2.5,0.983,2.5,2.498c0,1.514-0.983,2.494-2.5,2.494 H9.601c-1.517,0-2.5-0.98-2.5-2.494c0-1.515,0.983-2.498,2.5-2.498H42.484z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-4_3_",
    fill: "#FFFFFF",
    d: "M35.906,25.826c1.517,0,2.5,0.982,2.5,2.496s-0.983,2.494-2.5,2.494H16.567 c-1.517,0-2.5-0.98-2.5-2.494s0.983-2.496,2.5-2.496H35.906z"
  })))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-12_3_",
    fill: "#FEFEFE",
    d: "M36.459,21.479c0-3.567-2.896-6.454-6.46-6.454",
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGround);
export default __webpack_public_path__ + "static/media/ic-ground.e62e25b3259887ec7c579bde27ee0bef.svg";
export { ForwardRef as ReactComponent };